import * as React from "react";
import { useCountryValue } from "../Contexts/CountryContext";
export var ShowPhonesexDecider = function (props) {
  var showPhoneSex = window.layoutSettings.hash === "" && window.callData.webmasterDDI !== null;
  var state = useCountryValue()[0];
  if (!showPhoneSex || state.country !== "de") {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, props.children);
};